const groupCTXTag = document.getElementsByTagName("meta").group_ctx;
if (groupCTXTag) {
  const currentGroup = groupCTXTag.dataset;
  const maxRecentGroups =
    document.getElementsByTagName("meta").max_recent_groups.content;
  const { hcpgId } = document.getElementsByTagName("meta").current_user.dataset;

  let recentGroupStr = localStorage.getItem(`recentGroups-${hcpgId}`) || "[]";
  const recentGroups = JSON.parse(recentGroupStr);
  const recentGroupIds = recentGroups.map((g) => g.hcpgId);

  const alreadyRecent = recentGroups
    .filter((group) => group.hcpgId === currentGroup.hcpgId)
    .some(() => true);
  const atCapacity = recentGroups.length >= maxRecentGroups;

  if (alreadyRecent) {
    const index = recentGroupIds.indexOf(currentGroup.hcpgId);
    recentGroups.splice(index, 1);
  } else if (atCapacity) {
    recentGroups.shift();
  } else {
    // do nothing we are neither already in the recentGroups nor at capacity so we can just push ...
  }
  recentGroups.push(currentGroup);
  recentGroupStr = JSON.stringify(recentGroups);
  localStorage.setItem(`recentGroups-${hcpgId}`, recentGroupStr);
}
